module.exports = __webpack_public_path__ + "static/law of pleadings in civil court book-a0a7f57a0e317d026eacf4c45341675a.jpg";